import styles from "./styles/AccordionTerrace.module.scss"
import Markdown from "../../../utilities/Markdown";
import FontAwesome from "../../../utilities/FontAwesome";
import SchoolBlocksLoadingIndicator from "../../../utilities/SchoolBlocksLoadingIndicator";
import {useStores} from "../../../../stores/useStores";

interface SearchResult {
    headline: string,
    id: number,
    title: string,
    description: string,
    has_content: boolean,
    path: string,
    terrace: ITerrace,
    breadcrumbs: string,
}

interface AccordionItemSearchResultProps {
    result: SearchResult;
    index: number;
    results: SearchResult[];
}

const AccordionItemSearchResult: React.FC<AccordionItemSearchResultProps> = ({result, index, results}) => {
    const {modalStore} = useStores();

    const getItem = (idx) => {
        return results.length >= idx ? results[idx] : null;
    }

    const onClick = (e) => {
        e.stopPropagation();
        modalStore.addModal({
            type: "accordion",
            itemObj: result,
            totalItemCount: results.length,
            initialItemIndex: index,
            getItemAtIndex: getItem,
        })
    }
    return (
        <div className={styles.accordionSearchResult}>
            <h4 className="accordion-title">{result.title}</h4>
            <div className={styles.breadcrumbs}>
                {result.breadcrumbs}
            </div>
            <Markdown allowLinks={true} withStyles={true} source={result.headline}/>
            <button className={styles.viewMoreButton} onClick={onClick}>View More</button>
        </div>
    );
};


interface AccordionItemSearchResultListProps {
    results: SearchResult[];
    setIsSearching: React.Dispatch<React.SetStateAction<boolean>>;
    searchTerm: string;
    setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
    setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
    previousSearchTerm: string;
    isLoading: boolean;
}

const AccordionItemSearchResultList: React.FC<AccordionItemSearchResultListProps> = ({results, setIsSearching, searchTerm, setIsExpanded, setSearchTerm, previousSearchTerm, isLoading}) => {
    if (isLoading) return (
        <div className={styles.accordionSearchContainer}>
            <div className={styles.accordionSearchLoading}>
                <h3 className={styles.searchResultsTitle}>
                    Searching for &apos;{searchTerm}&apos;...
                </h3>
                <SchoolBlocksLoadingIndicator/>
            </div>
        </div>
    )
    else {
        return (
            <div className={styles.accordionSearchContainer}>
                <div className={styles.accordionSearchHeader}>
                    <div className={styles.goBackWrapper}>
                        <button className={styles.goBackButton} onClick={() => {setIsSearching(false); setIsExpanded(false); setSearchTerm("");}}>
                            <FontAwesome prefix={'fas'} name={'fa-arrow-left'}/>&nbsp;Go Back
                        </button>
                    </div>
                    <h3 className={styles.searchResultsTitle}>
                        {results.length} Search Result{results.length !== 1 && 's'} for &apos;{previousSearchTerm}&apos;
                    </h3>
                </div>

                {results.length > 0 && results.map((result, index) => (
                    <AccordionItemSearchResult
                        key={result.id}
                        index={index}
                        result={result}
                        results={results}
                    />
                )) }
            </div>
        );
    }

};

export {AccordionItemSearchResultList, AccordionItemSearchResult};
